var COOKIE_FEATURE_URL_TYPE = 'url';
var COOKIE_FEATURE_INTERNAL_TYPE = 'internal';
var COOKIE_FEATURE_EXPIRATION_SESSION = 'session';
var COOKIE_FEATURE_EXPIRATION_LIFETIME = 'lifetime';
var featureCookie= ( function(){

    var domain = "." + getDomainName();
    var types = [COOKIE_FEATURE_URL_TYPE, COOKIE_FEATURE_INTERNAL_TYPE];
    var whitelist={};//whitelist of cookies, separated by feature type

    whitelist[COOKIE_FEATURE_URL_TYPE] = [];



    function getDomainName (){

        if (typeof BmConfig !== 'undefined') {
            return BmConfig.sitename;
        }
        else {
            return getSiteDomain(window.location.hostname);
        }
    }

// Helper function to extract domain from URL
    function getSiteDomain(url) {
        var urlParts = url.replace('http://','').replace('https://','').split('.').reverse();
        return urlParts[1] + '.' + urlParts[0];
    }

    function checkIfInWhiteList(name, type){ // check if exists in whitelist - returns true/false
        if(type==COOKIE_FEATURE_INTERNAL_TYPE) return true;

        if (!whitelist[type]) return false;

        for(var j=0; j<whitelist[type].length; j++){
            if(whitelist[type][j]==name) return true;
        }


        return false;
    }

    function checkIfExists(name, type){ // check if cookie already exists or not - returns true/false
        var cookieName = getCookieName(name, type);
        return docCookies.hasItem(cookieName);
    }

    function getCookieName(name, type) { // create cookie name according to it's type
        return "feature." + name + "." + type;
    }

    /**
     *
     * @param name
     * @param value
     * @param type
     * @param time (int - expiration date / string 'session' or 'lifetime')
     */
    function setData(name, value, type, time) { // create/update a cookie according to name, value and type. time - expiration.
        //if time not set - time will be until the end of the session
        var exists = checkIfExists(name, type);
        if(!time){
            throw "featurecookie.setData missing argument time";
        }
        if(time == COOKIE_FEATURE_EXPIRATION_LIFETIME){
            time = new Date();
            time.setFullYear(time.getFullYear() + 1);
        }
        else if(time == COOKIE_FEATURE_EXPIRATION_SESSION){
            time = null ;
        }

        if(checkIfInWhiteList(name, type)){
            var cookieName = getCookieName(name, type);
            docCookies.setItem(cookieName, value , time, '/', domain);
            return (exists)?2:1; // returns 1 if created and 2 if updated
        }


        return 0; // can't set cookie - not on whitelist
    }

    function getData(name, type) {
        var cookieName ;
        if(!type){
            for(var i=0; i< types.length; i++){
                cookieName = getCookieName(name, types[i]);
                if(docCookies.hasItem(cookieName))
                    return docCookies.getItem(cookieName) ;
            }
        }
        else{
            return docCookies.getItem(getCookieName(name, type));
        }

        return false ;
    }

    function removeData(name, type){
        var cookieName = getCookieName(name, type);
        docCookies.removeItem(cookieName, "/", domain);
    }

    return  {
        setData:    setData,
        getData:    getData,
        removeData: removeData
    }
})();

function setUrlCookies(){//takes url params in current page and create cookies
    var allParams = getUrlParams();

    for(var key in allParams){
        featureCookie.setData(key, allParams[key],COOKIE_FEATURE_URL_TYPE , COOKIE_FEATURE_EXPIRATION_SESSION);
    }
}


$(document).ready(function(){
    setUrlCookies();
});

/**
 * Examples -
 * type - COOKIE_FEATURE_INTERNAL_TYPE/COOKIE_FEATURE_URL_TYPE - cookie from url or internal
 * get cookie  - featureCookie.getData(cookieName)
 * set cookie - featureCookie.setData(cookieName, cookieValue, type)
 * remove cookie - featureCookie.removeData(cookieName, type)
 */
